/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./model-previewer.vue?vue&type=template&id=2d143be5&"
import script from "./model-previewer.vue?vue&type=script&lang=ts&"
export * from "./model-previewer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports